import React from 'react';

import Content from '@components/Dashboard/AdminPanel/Trial';

const Trial: React.FC = () => {
  return <Content />;
};

export default Trial;
